import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11a21588&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a21588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a21588')) {
      api.createRecord('11a21588', component.options)
    } else {
      api.reload('11a21588', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=11a21588&scoped=true", function () {
      api.rerender('11a21588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/commentSetting/index.vue"
export default component.exports